<script lang="ts">
    import type {User} from 'src/typings';
    import KpUserInfoCard from '../../../../../../features/user/KpUserInfoCard.svelte';

    export let value: User;
</script>

<KpUserInfoCard user={value}/>